<template>
  <div>Loading...</div>
</template>

<script>
export default {
  name: 'BattleLoad'
}
</script>
